/*
 * Author: Danny Ehlers
 * Date: 8/16/2018
 * Http Interceptor to start and stop the custom spinner on each request. Using this strategy,
 * a developer does not need to concern themselves with manually starting and stoping a spinner.
 */
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { finalize } from 'rxjs/operators';
import { CapSpinnerService } from './cap-spinner.service';

@Injectable({
  providedIn: 'root'
})
export class CapSpinnerHttpInterceptorService implements HttpInterceptor{

  constructor(private capSpinnerService: CapSpinnerService) { }

  //intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //  this.capSpinnerService.spinnerShow();
  //  return next.handle(request).finally(() => {
  //    this.capSpinnerService.spinnerHide();
  //  });
  //}
  count = 0;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.capSpinnerService.spinnerShow();
    this.count++;
    return next.handle(request).pipe(
      finalize(() => {
        this.count--;
        if (this.count == 0)
          this.capSpinnerService.spinnerHide();
    }));
  }
  
}
